/** events — EN source (204 keys). */
export const events = {
  events_title: "Events",
  events_nearby: "Nearby",
  events_all: "All Events",
  events_my_events: "My Events",
  events_create: "Create Event",
  events_list_empty_title: "No events found",
  events_list_empty_description: "Check back later or create your own event",
  events_list_loading: "Loading events...",
  events_list_error: "Failed to load events",
  events_list_search_placeholder: "Search events...",
  events_list_filter_title: "Filter Events",
  events_filter_all: "All",
  events_filter_today: "Today",
  events_filter_this_week: "This Week",
  events_filter_this_month: "This Month",
  events_filter_online: "Online",
  events_filter_in_person: "In Person",
  events_filter_free: "Free",
  events_filter_paid: "Paid",
  events_filter_apply: "Apply Filters",
  events_filter_clear: "Clear",
  events_card_free: "Free",
  events_card_from_price: "From {price}",
  events_card_sold_out: "Sold Out",
  events_card_tickets_left: "{count} tickets left",
  events_card_online: "Online Event",
  events_card_distance: "{distance} mi away",
  events_detail_about: "About",
  events_detail_location: "Location",
  events_detail_date_time: "Date & Time",
  events_detail_organizer: "Organizer",
  events_detail_performers: "Performers",
  events_detail_tickets: "Tickets",
  events_detail_get_tickets: "Get Tickets",
  events_detail_buy_ticket: "Buy Ticket",
  events_detail_reserve_spot: "Reserve Spot",
  events_detail_view_ticket: "View My Ticket",
  events_detail_share: "Share Event",
  events_detail_report: "Report Event",
  events_detail_directions: "Get Directions",
  events_detail_online_event: "This is an online event",
  events_detail_join_online: "Join Online",
  events_status_draft: "Draft",
  events_status_published: "Published",
  events_status_cancelled: "Cancelled",
  events_status_completed: "Completed",
  events_form_title: "Event Title",
  events_form_title_placeholder: "Give your event a name",
  events_form_description: "Description",
  events_form_description_placeholder:
    "Tell people what your event is about...",
  events_form_start_date: "Start Date & Time",
  events_form_end_date: "End Date & Time",
  events_form_location: "Location",
  events_form_location_placeholder: "Add event location",
  events_form_online_event: "This is an online event",
  events_form_online_url: "Event URL",
  events_form_online_url_placeholder: "https://zoom.us/...",
  events_form_price: "Ticket Price",
  events_form_price_free: "Free Event",
  events_form_max_tickets: "Maximum Tickets",
  events_form_max_tickets_placeholder: "Unlimited",
  events_form_tags: "Event Tags",
  events_form_tags_placeholder: "Select tags...",
  events_form_photos: "Event Photos",
  events_form_add_photos: "Add Photos",
  events_form_visibility: "Visibility",
  events_form_visibility_public: "Public",
  events_form_visibility_private: "Private",
  events_form_visibility_followers: "Followers Only",
  events_form_save_draft: "Save as Draft",
  events_form_publish: "Publish Event",
  events_form_update: "Update Event",
  events_form_creating: "Creating event...",
  events_form_updating: "Updating event...",
  events_validation_title_required: "Event title is required",
  events_validation_start_date_required: "Start date is required",
  events_validation_end_date_required: "End date is required",
  events_validation_end_after_start: "End date must be after start date",
  events_validation_location_required:
    "Location is required for in-person events",
  events_validation_online_url_required: "URL is required for online events",
  events_success_created: "Event created successfully",
  events_success_updated: "Event updated successfully",
  events_success_published: "Event published successfully",
  events_success_cancelled: "Event cancelled",
  events_success_deleted: "Event deleted",
  events_admin_edit: "Edit Event",
  events_admin_manage_tickets: "Manage Tickets",
  events_admin_cancel_event: "Cancel Event",
  events_admin_delete_event: "Delete Event",
  events_admin_cancel_confirm_title: "Cancel Event?",
  events_admin_cancel_confirm_message:
    "Are you sure you want to cancel this event? All ticket holders will be notified.",
  events_admin_delete_confirm_title: "Delete Event?",
  events_admin_delete_confirm_message:
    "Are you sure you want to delete this event? This action cannot be undone.",
  tickets_my_tickets: "My Tickets",
  tickets_upcoming: "Upcoming",
  tickets_past: "Past",
  tickets_empty_title: "No tickets yet",
  tickets_empty_description:
    "When you get tickets for events, they'll appear here",
  tickets_loading: "Loading tickets...",
  tickets_card_active: "Active",
  tickets_card_used: "Used",
  tickets_card_cancelled: "Cancelled",
  tickets_card_expired: "Expired",
  tickets_card_banned: "Banned",
  tickets_card_view: "View Ticket",
  tickets_card_type_standard: "Standard",
  tickets_card_type_vip: "VIP",
  tickets_card_type_early_bird: "Early Bird",
  tickets_card_type_group: "Group",
  tickets_qr_title: "Your Ticket",
  tickets_qr_scan_instruction: "Show this QR code at the entrance",
  tickets_qr_generating: "Generating QR code...",
  tickets_qr_error: "Failed to generate QR code",
  tickets_qr_refresh: "Refresh QR Code",
  tickets_qr_valid_until: "Valid until {time}",
  tickets_qr_ticket_id: "Ticket ID: {id}",
  tickets_purchase_title: "Get Ticket",
  tickets_purchase_select_type: "Select Ticket Type",
  tickets_purchase_price: "Price",
  tickets_purchase_free: "Free",
  tickets_purchase_confirm: "Confirm",
  tickets_purchase_processing: "Processing...",
  tickets_purchase_success: "Ticket purchased successfully!",
  tickets_purchase_error: "Failed to purchase ticket",
  tickets_purchase_sold_out: "Sorry, this event is sold out",
  tickets_purchase_already_have: "You already have a ticket for this event",
  tickets_cancel_title: "Cancel Ticket?",
  tickets_cancel_message:
    "Are you sure you want to cancel this ticket? This action cannot be undone.",
  tickets_cancel_confirm: "Cancel Ticket",
  tickets_cancel_success: "Ticket cancelled",
  tickets_cancel_error: "Failed to cancel ticket",
  tickets_checkin_title: "Check In",
  tickets_checkin_scan: "Scan QR Code",
  tickets_checkin_manual: "Enter Ticket ID",
  tickets_checkin_success: "Check-in successful!",
  tickets_checkin_already_used: "This ticket has already been used",
  tickets_checkin_invalid: "Invalid ticket",
  tickets_checkin_cancelled: "This ticket has been cancelled",
  tickets_checkin_wrong_event: "This ticket is for a different event",
  tickets_payment_pending: "Payment Pending",
  tickets_payment_paid: "Paid",
  tickets_payment_free: "Free",
  tickets_payment_refunded: "Refunded",
  events_miniapp_search_placeholder: "Search events...",
  events_miniapp_no_events: "No events yet",
  events_miniapp_no_events_description:
    "Be the first to create an event and bring people together.",
  events_miniapp_new_event: "New Event",
  events_miniapp_detail: "Event Details",
  events_miniapp_buy_ticket: "Buy Ticket",
  events_miniapp_sold_out: "Sold Out",
  events_miniapp_free: "Free",
  events_miniapp_tickets_left: "{count} tickets left",
  events_miniapp_date: "Date",
  events_miniapp_price: "Price",
  events_miniapp_description: "Description",
  events_miniapp_status_upcoming: "Upcoming",
  events_miniapp_status_ongoing: "Ongoing",
  events_miniapp_status_completed: "Completed",
  events_miniapp_status_cancelled: "Cancelled",
  events_miniapp_organizer: "Organizer",
  events_miniapp_tags: "Tags",
  events_miniapp_address: "Address",
  events_miniapp_my_tickets: "My Tickets",
  events_miniapp_no_tickets: "No tickets yet",
  events_miniapp_browse_events: "Browse events",
  events_miniapp_ticket_status_active: "Active",
  events_miniapp_ticket_status_used: "Used",
  events_miniapp_ticket_status_cancelled: "Cancelled",
  events_miniapp_ticket_sales: "Ticket Sales",
  events_miniapp_total_tickets: "Total",
  events_miniapp_checked_in: "Checked In",
  events_miniapp_revenue: "Revenue",
  events_miniapp_cancel_event: "Cancel Event",
  events_miniapp_delete_event: "Delete Event",
  events_miniapp_you_have_ticket: "You have a ticket",
  events_miniapp_title_label: "Event Title",
  events_miniapp_description_label: "Description",
  events_miniapp_price_label: "Price ($)",
  events_miniapp_max_tickets_label: "Max Tickets",
  events_miniapp_creating: "Creating...",
  events_miniapp_purchasing: "Purchasing...",
  events_miniapp_company_events: "Company Events",
  events_miniapp_view_tickets: "View Tickets",
  events_miniapp_manage: "Manage",
  events_miniapp_create: "Create",
  events_miniapp_required_hint: "Fields marked * are required",
  events_miniapp_error_title_required: "Enter an event title",
  events_miniapp_error_date_required: "Choose a start date and time",
  events_miniapp_error_date_past: "Start time must be in the future",
  events_miniapp_business_badge: "Business",
  events_miniapp_hosted_by: "Hosted by",
  events_miniapp_events_count: "{count} event(s)",
  events_miniapp_featured: "Featured",
  events_miniapp_all_events: "All events",
  events_miniapp_tab_upcoming: "Upcoming",
  events_miniapp_tab_past: "Past",
  events_miniapp_tab_tickets: "Tickets",
  events_miniapp_no_past_events: "No past events",
  events_miniapp_view_qr: "View Ticket / QR Code",
  events_miniapp_ticket_qr_title: "Event QR Code",
  events_miniapp_ticket_qr_scan_hint:
    "Show this code at the entrance to check in.",
  events_miniapp_ticket_qr_unavailable:
    "QR code unavailable. The ticket may be inactive.",
  events_miniapp_receipt_title: "Receipt",
  events_miniapp_your_booking: "Your Booking",
  events_miniapp_event: "Event",
  events_miniapp_ticket_type: "Ticket",
  events_miniapp_price_details: "Price Details",
  events_miniapp_app_fee: "App fee",
  events_miniapp_total: "Total",
};
